import React from "react";
import { Grid, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { ModernLiquidTable } from "../../../../components/modern-table";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { getAdmin } from "../../../../api/user";
import exportToExcel from "../../../../utils/exportToExcel";


export default function AdminsPage(props) {
  const [adminRows, setAdminRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const authToken = useSelector(({auth}) => auth.authToken);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAdmin(authToken);
      if (data) {
        setAdminRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [authToken]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "name", title: "Nama", width: 300 },
    {
      field: "email",
      title: "E-mel",
    },
    { field: "branch", title: "Cawangan Gema" },
  ];

  const handleExport = (columns, data) => {
    const exportData = data.map((admin) => ({
      Nama: admin.name,
      Email: admin.email,
      Cawangan: admin.branch,
    }));
    exportToExcel(exportData);
  };

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <span className="kt-section__sub">
                Senarai admin yang aktif untuk menguruskan sistem.
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={adminRows}
              title={`Senarai Admin: ${adminRows.length}`}
              loading={loading}
              onRefresh={fetchData}
              exportFunction={handleExport}
              emptyStateMessage="Tiada admin berdaftar"
              options={{
                selection: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
